import { render } from "./ProjectUpdatesContent.vue?vue&type=template&id=6e4d01b3"
import script from "./ProjectUpdatesContent.vue?vue&type=script&lang=js"
export * from "./ProjectUpdatesContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__